import React, { useCallback } from 'react'
import BenefitBanner from '~/app/components-nds/common/benefit-banner'
import { MessageBox } from '@yanolja-rnd/nol-design-system'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'
import { DomesticCartBenefitBanner } from '~/api/converters/domestic/cart/BenefitBanner/index.type'
import { CartPageLog } from '~/app/kinesis/protobuf/clientlogs/order-misc-common-txtpb'

const CartBannerGuide = ({ image, action, logMeta }: DomesticCartBenefitBanner) => {
  const onBannerClickLog = useCallback(async () => {
    if (!action) return

    const yaNative = getYaNative()
    const isNativeEnv = isNative(yaNative)

    const link = isNativeEnv ? action.app : action.web

    if (logMeta && link) {
      await CartPageLog.BenefitBannerId.click({
        benefitBannerId: logMeta.id,
        benefitBannerTitle: logMeta.title,
        deepLinkUri: link,
      })
    }
  }, [logMeta, action])

  const onBannerImpressed = useCallback(async () => {
    if (!logMeta || !action) return

    await CartPageLog.BenefitBannerId.impression({
      benefitBannerId: logMeta.id,
      benefitBannerTitle: logMeta.title,
    })
  }, [action, logMeta])

  return (
    <div className={'flex w-full flex-col gap-16 bg-static-white pf-pc:gap-20'}>
      {image && action && (
        <BenefitBanner
          imageUrl={image}
          action={action}
          onImpressed={onBannerImpressed}
          onClickLog={onBannerClickLog}
        />
      )}
      <MessageBox theme="info" align="left" type="multiple" className="pf-pc:px-16 pf-pc:py-12">
        <ul className="flex flex-col gap-8 pl-16 typography-body-13-regular-multiline">
          <li className="list-disc">
            장바구니에 담은 상품은 최대 30일간 보관되고 최대 20개까지 담을 수 있어요.
          </li>
          <li className="list-disc">
            장바구니에서 수량 및 상세 옵션을 변경할 수 없는 상품도 있어요. 삭제 후 다시 담아주세요.
          </li>
          <li className="list-disc">
            쿠폰 및 포인트가 적용된 최종 결제 금액은 다를 수 있으므로 예약화면에서 확인해 주세요.
          </li>
        </ul>
      </MessageBox>
    </div>
  )
}

export default CartBannerGuide
